import { render } from "./CustomerDistributionEmptySlot.vue?vue&type=template&id=52755128"
const script = {}

import "./CustomerDistributionEmptySlot.vue?vue&type=style&index=0&id=52755128&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__